var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadMidiplug = function SvgFadMidiplug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 193.901c-13.606 0-21.823 9.814-23.434 22.258C62.374 207.79 36 172.65 36 128c0-50.81 41.19-92 92-92s92 41.19 92 92c0 44.21-25.713 77.476-67.501 86.16-1.346-8.684-11.008-20.259-24.499-20.259z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.756 175.45c-16.6 0-29.661 9.166-31.756 19.178C74.568 189.702 52.687 163.28 52.687 128c0-40.149 37.205-76 75.313-76 38.108 0 74.826 35.851 74.826 76 0 23.164-11.485 58.322-42.826 65.183-2.587-6.861-15.643-17.733-32.244-17.733z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 80,
    cy: 125,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 95,
    cy: 92,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 128,
    cy: 79,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 161,
    cy: 92,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 174,
    cy: 124,
    r: 11
  }))));
};
export { SvgFadMidiplug as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-midiplug.63bc2e41.svg";